
define('template!ordersDetailInvoicesSentDateView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="date">' +
((__t = ( date )) == null ? '' : __t) +
'</div>';

}
return __p
};});

